import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import { Badge } from "./ui/badge";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { formatDate } from "../lib/articles";

function ArticleCard({ article }) {
  return (
    <Card className="group flex h-full flex-col bg-card/80 transition-colors hover:border-primary/40">
      <CardHeader className="pb-4">
        <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
          <time dateTime={article.date}>{formatDate(article.date)}</time>
          <span aria-hidden="true">·</span>
          <span>{article.readingTime}</span>
        </div>
        <CardTitle className="pt-2">
          <Link
            to={`/articles/${article.slug}`}
            className="transition-colors group-hover:text-primary"
          >
            {article.title}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1">
        <p className="text-sm leading-6 text-muted-foreground">{article.excerpt}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {article.tags.map((tag) => (
            <Badge key={tag} variant="secondary" className="font-normal">
              {tag}
            </Badge>
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <Link
          to={`/articles/${article.slug}`}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary"
        >
          Read article <ArrowUpRight className="h-4 w-4" />
        </Link>
      </CardFooter>
    </Card>
  );
}

export default ArticleCard;
